<template>
  <div id="slide_box" class="report_douwnload">
    <div id="slide_content" :style="{background: color}">
      <div class="slide_block" id="report_douwnload" :class="getShowClass()">
         <div class="slide_animate_block">
          <div class="bg" :style="{background: color}">
            <div class="wrap03 main_area">
              <div class="info_msg_box">
                <div>{{ $msg.INFO.MSG_0003 }}</div>
                <div>{{ $msg.INFO.MSG_0004 }}</div>
                <div>{{ $msg.INFO.MSG_0005 }}</div>
              </div>
              <CommonErrorMsgArea />
              <p class="error main_error" v-if="error.invalid_input">{{$msg.ERROR.MSG_0035}}</p>
              <div class="wrap02 form_area">
                <div class="form_block_01">
                  <div class="input_box_01">
                    <div class="input_title">申込ID</div>
                    <input type="text" name="applyId" class="input" v-model="applyId" maxlength="18">
                  </div>
                  <p class="error" v-if="error.required_applyId">{{$msg.ERROR.MSG_0036}}</p>
                </div>
                <div class="form_block_01">
                  <div class="input_box_01">
                    <div class="input_title">メールアドレス</div>
                    <input type="text" name="email" class="input" placeholder="sg_renet@renet.jp" v-model="email" maxlength="50" @change="formatToLowerEmail">
                  </div>
                  <p class="error" v-if="error.required_email">{{$msg.ERROR.MSG_0014}}</p>
                  <p class="error" v-if="error.invalid_email">{{$msg.ERROR.MSG_0015}}</p>
                </div>
                <div class="form_block_01">
                  <div class="input_box_01">
                    <div class="input_title">電話番号</div>
                    <input type="tel" name="tel" class="input" placeholder="0123456789（ハイフン不要）" @input="pickupTell = delete_hyphen($event)" :value="pickupTell" maxlength="11">
                  </div>
                  <p class="error" v-if="error.required_pickupTell">{{$msg.ERROR.MSG_0032}}</p>
                  <p class="error" v-if="error.invalid_pickupTell">{{$msg.ERROR.MSG_0033}}</p>
                </div>
              </div>
              <div class="action_area">
                <button type="button" class="form-Button-01" :style="{backgroundColor : nextPageColor}" @click="submitReportDownloadForm" :disabled="disableFlg">契約書ダウンロード</button>
              </div>
            </div>
          </div>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonErrorMsgArea from '@/components/pc/CommonErrorMsgArea'
import ReportDownloadForm from '../../js/ReportDownloadForm'

export default {
  props: {
    siteCodeInfo: Array,
    siteCodeItem: Array
  },
  data() {
    return {
      applyId: "",
      email: "",
      pickupTell: "",
      error: {
        invalid_input: false,
        required_applyId: false,
        required_pickupTell: false,
        invalid_pickupTell: false,
        required_email: false,
        invalid_email: false
      }
    }
  },
  computed: {
    color: ReportDownloadForm.getColor,
    disableFlg: ReportDownloadForm.getDisableFlg,
    nextPageColor: ReportDownloadForm.getNextPageColor,
  },

  created() {
  },
  methods: {
    submitReportDownloadForm() {
      ReportDownloadForm.submitReportDownloadForm(this)
    },
    delete_hyphen(event) {
      return ReportDownloadForm.deleteHyphen(event.target.value)
    },
    formatToLowerEmail() {
        // フォーカスアウト（change）のタイミングでデータを小文字に上書き
        ReportDownloadForm.formatToLowerEmail(this);
    }
  },
  components: { CommonErrorMsgArea }
}
</script>
